<div class="flex items-center" [ngClass]="isMobileView ? 'flex-col-reverse':'gap-5'" >
    <span class="h-3 text-sm font-semibold text-default sm:text-xs">{{checkedQuestions}}/{{totalQuestions}}</span>
    <div [ngClass]="isMobileView? 'w-10':'w-36'">
        <kendo-progressbar  [class.h-3]="isMobileView" [value]="((checkedQuestions/totalQuestions)*100)" [label]="{visible: false}" [animation]="true"></kendo-progressbar>
    </div>
</div>
